import React from 'react';
import styles from './VIPCommunitySection.module.scss';
import SectionBadge from '../components/SectionBadge';
import CTAButton from '../components/CTAButton';

const VIPCommunitySection = ({ onGetAccess }) => {
  return (
    <section className={styles.community}>
      <div className={styles.container}>
        <div className={styles.header}>
          <SectionBadge>VIP community</SectionBadge>
          <h2 className={styles.headline}>
            <em>You're not just signing up for software. You're stepping into a community of AI-driven entrepreneurs and professionals.</em>
          </h2>
          <p className={styles.description}>
            Inside our community, you get premium support, advanced workshops, and the collective knowledge of people who are pushing the boundaries of what's possible with AI. If you want to master content strategy and execution with the right system, this is where you do it.
          </p>
          <CTAButton onClick={onGetAccess}>
            Get lifetime access for $399 only
          </CTAButton>
        </div>

        <div className={styles.showcase}>
          <img
            src="/Images/VIPCommunity.png"
            alt="VIP Community - Live Workshops and Tutorials"
            className={styles.showcaseImage}
          />
        </div>
      </div>
    </section>
  );
};

export default VIPCommunitySection;
